import faqContent from './content/faq.json';

const faqMock = {
    layoutType: 2,
    data: {
        name: 'faq',
        layoutType: 2,
        areasList: [
            {
                id: 'faq-page-area',
                name: 'Content',
                componentName: 'Comp:FaqPage',
                content: JSON.stringify(faqContent),
            },
        ],
    },
};

export default faqMock;
